import React from 'react';
import { FormGroup, Label, Input, Row, Col } from 'reactstrap';

const ColorPickerInput = ({ label, value, onChange, placeholder, id }) => {
    const presets = {
        'var(--bs-white)': 'Weiß',
        'var(--bs-body-color)': 'Standard-Textfarbe',
        'var(--bs-primary)': 'Primärfarbe',
        'var(--bs-secondary)': 'Sekundärfarbe',
    };

    let selectedOption = '';
    let customValue = '';

    if (!value) {
        selectedOption = '';
    } else if (value in presets) {
        selectedOption = value;
    } else {
        selectedOption = 'custom';
        customValue = value;
    }

    const handleSelectChange = (e) => {
        const val = e.target.value;
        if (val === 'custom') {
            onChange(customValue || '#ffffff');
        } else {
            onChange(val || undefined);
        }
    };

    const handleTextChange = (e) => {
        const val = e.target.value;
        onChange(val || undefined);
    };

    return (
        <FormGroup className="mb-2">
            {label && (
                <Label className="text-muted small mb-1" for={id}>
                    {label}
                </Label>
            )}
            <Row className="g-2">
                <Col xs={selectedOption === 'custom' ? '6' : '12'}>
                    <Input type="select" id={id} value={selectedOption} onChange={handleSelectChange}>
                        <option value="">Standard</option>
                        <option value="var(--bs-white)">Weiß</option>
                        <option value="var(--bs-body-color)">Standard-Textfarbe</option>
                        <option value="var(--bs-primary)">Primärfarbe</option>
                        <option value="var(--bs-secondary)">Sekundärfarbe</option>
                        <option value="custom">Benutzerdefiniert</option>
                    </Input>
                </Col>
                {selectedOption === 'custom' && (
                    <Col xs="6">
                        <Input
                            type="text"
                            value={customValue}
                            onChange={handleTextChange}
                            placeholder={placeholder || 'z.B. #ff0000'}
                        />
                    </Col>
                )}
            </Row>
        </FormGroup>
    );
};

export default ColorPickerInput;
